// extracted by mini-css-extract-plugin
export default {"errorScreen":"ErrorScreen_errorScreen__43J9t","heading":"ErrorScreen_heading__dPE06","errorStr":"ErrorScreen_errorStr__7WajP","stack":"ErrorScreen_stack__2XGVZ"};